import PhotoSwipeLightbox from 'photoswipe/lightbox';
//Pswp
export default class Pswp {
    //event handlers
    #handlers;

    /**
     * call
     * @returns {Boolean}
     */
    call() {
        let key = arguments[0];
        if (!this.#handlers[key]) {
            return true;
        }
        const args = Array.prototype.slice.call(arguments, 1);
        for (let func of this.#handlers[key]) {
            if (typeof func === 'function' && func(...args) === false) {
                return false;
            }
        }
    }
    /**
     * on
     * @param {type} key
     * @param {type} func
     * @returns {undefined}
     */
    on(key, func) {
        if (typeof func !== 'function') {
            return;
        }
        if (!this.#handlers[key]) {
            this.#handlers[key] = [];
        }
        this.#handlers[key].unshift(func);
    }

    /**
     * off
     * @param {type} key
     * @param {type} func
     * @returns {undefined}
     */
    off(key, func) {
        if (!this.#handlers[key]) {
            return;
        }
        for (let idx = this.#handlers[key].length - 1; idx >= 0; --idx) {
            if (this.#handlers[key][idx] === func) {
                this.#handlers[key].splice(idx, 1);
            }
        }
    }

    #opening;
    get opening() {
        return this.#opening;
    }

    //pswp
    #lightbox = null;

    /**
     * open
     * @param {type} idx
     * @returns {undefined}
     */
    open(idx) {
        this.#lightbox && this.#lightbox.loadAndOpen(idx);
    }
    /**
     * load data source
     * @param {type} ds
     * @returns {undefined}
     */
    load(ds) {
        if (!Array.isArray(ds)) {
            return;
        }
        this.destroy();
        if (!ds.length) {
            return;
        }
        const instance = new PhotoSwipeLightbox({
            dataSource: ds.map(image => {
                return{
                    id: image.id,
                    src: image.src,
                    alt: image.alt
                };
            }),
            pswpModule: () => import('photoswipe')
        });
        instance.on('uiRegister', function () {
            instance.pswp.ui.registerElement({
                name: 'custom-caption',
                order: 9,
                isButton: false,
                appendTo: 'root',
                html: 'Caption text',
                onInit: (el) => {
                    instance.pswp.on('change', () => {
                        el.innerHTML = instance.pswp.currSlide.data.alt || '';
                    });
                }
            });
        });
        instance.init();

        instance.on('change', () => {
            const idx = instance.pswp.currIndex;
            this.call('image-changed', instance.pswp.options.dataSource[idx]);
        });
        instance.on('close', () => {
            this.#opening = false;
            this.call('close');
        });
        instance.on('openingAnimationStart', () => {
            this.#opening = true;
            this.call('open');
        });
        this.#lightbox = instance;
    }
    /**
     * destroy
     * @returns {undefined}
     */
    destroy() {
        if (!this.#lightbox) {
            return;
        }
        this.#lightbox.destroy();
        this.#lightbox = null;
    }

    getDataSource() {
        return (this.#lightbox && this.#lightbox.options && this.#lightbox.options.dataSource) || [];
    }

    openByImg(img) {
        const idx = this.getDataSource().findIndex(image => image.id === img.id);
        idx >= 0 && this.open(idx);
    }

    constructor() {
        this.#handlers = {};
        this.#lightbox = null;
        this.#opening = false;
    }
}
